module.exports = __webpack_public_path__ + "static/media/cstore-hero.ae4ed78e.jpg";